import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectOrderTypePage } from '../modals/select-order-type/select-order-type.page';
import { AlertPage } from '../modals/alert/alert.page';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-ordering-main2',
  templateUrl: './ordering-main2.page.html',
  styleUrls: ['./ordering-main2.page.scss'],
})
export class OrderingMain2Page implements OnInit {

  slug: any;
  public scrollitem = 'scroll-to-class-0';
  private safeScroll: any = Date.now();
  private openCart: boolean = false;

  // show/hide welcome gift fab
  public showCard = false;
  public showGiftFabIcon:boolean = false;

  public cardTitle:string = '';
  public cardDescription:string = '';

  public specialOpenCloseMsg: string = '';
  public showSpecialOpenCloseError: boolean = false;

  public menuLoadingCompleteCallBack:any = null;

  constructor(private route: ActivatedRoute, public appService: AppServiceService, public modalController: ModalController,
    private router: Router, private translate: TranslateService, private location:Location) {
    this.route.params.subscribe((param) => {
      this.slug = param.slug;
      this.appService.startHeartBeat(this.slug);
    });

    // check if user navigated from login page, if user came from login page back btn then open cart
    this.route.queryParams.subscribe(async (param) => {
      if (param && param.openCart && param.openCart === 'true') this.openCart = true;
      // if (param && param.markedAsFavourite && param.markedAsFavourite === 'true') {
      //   const modal = await this.modalController.create({
      //     component: AlertPage,
      //     cssClass: 'custom-popup',
      //     componentProps: {
      //       'type': 'favourite-restaurant'
      //     }
      //   });
      //   setTimeout(async () => {
      //     await modal.present();
      //   }, 2000);
      // }
      // console.log('Is mobile web:',this.appService.isMobileWeb(),param);-
      // redirect after paypal payment on mobile web
      if (param) {
        if (param.checkoutStatus === 'false') {
          this.translate.get('key.payment_faild_msg').toPromise().then((response) => {
            this.appService.showToast(response, 'danger', 5000);
          });
        } else if (param.checkoutStatus === 'true' && param.paymentId) {
          await this.appService.clearCart();
          this.appService.clearCartCalled = true;

          if (param.subscription === 'true') {
            this.router.navigate(['subscription-summery', param.paymentId]);
          } else {
            this.router.navigate(['order-summery', param.paymentId]);
          }
        }

        // when user came from order summary page order same again feature
        if (param.re_order === 'true' && this.appService.appObject.reOrderObject) {
          // this.doNotTriggerParamChanges = true;
          // Update the URL in the address bar without reloading, to remove parameters
          const urlWithoutQueryParams = this.router.createUrlTree([], { relativeTo: this.route, queryParams: {} }).toString();
          this.location.go(urlWithoutQueryParams);

          this.appService.reorderInProgress = true;

          if (!this.menuLoadingCompleteCallBack) {
            this.menuLoadingCompleteCallBack = this.appService.watchDishesGettingLoaded().subscribe(async (response) => {
              // console.log('All Dishes Are Loaded : ' , this.appService.appObject.reOrderObject);

              // clear cart items that are not added by today, this was introduced when cart item edit feature implementation
              this.appService.clearCartItemsThatAreNotAddedByToday();

              let orderObject = this.appService.appObject.reOrderObject;
              // this.appService.appObject.reOrderObject = null;

              this.appService.addItemsToCartFromSelectedOrder();

              this.appService.reorderInProgress = false;
            });
          } else {
            if (!this.menuLoadingCompleteCallBack) {
              this.menuLoadingCompleteCallBack = this.appService.watchDishesGettingLoaded().subscribe(async (response) => {
                // clear cart items that are not added by today, this was introduced when cart item edit feature implementation
                this.appService.clearCartItemsThatAreNotAddedByToday();
              });
            }
          }
        }
      }
    });
  }

  scroll(id) {
    console.log('scrolling');
    this.scrollitem = id;
    /*document.getElementById(id).scrollIntoView(true);
    window.scrollBy(0, -70);*/
    const yOffset = -48;
    let element = document.querySelectorAll<HTMLElement>('#' + id)[0];
    let ioncontent = document.querySelectorAll<HTMLElement>('.my-ion-content')[0];
    const y = element.offsetTop - 48;

    //@ts-ignore
    ioncontent.scrollToPoint(0, y);
  }

  ngOnInit() {
    this.appService.className2 = '';
    //clear cart items that are not added by today
    this.appService.clearCartItemsThatAreNotAddedByToday();
  }

  async ionViewDidEnter() {

    // reset the selected time slot to calculate cart amounts
    this.appService.appObject.selectedTimeSlot = '';
    this.appService.updateAppObject();

    this.checkHasSecialOpenCloseDayNear();
    this.appService.close_note_toggle = true;
    this.appService.hideCartButton = true;
    await this.appService.getRestaurantBySlug(this.slug);
    setTimeout(() => {
      this.appService.hideCartButton = false;
    }, 1000);

    this.route.queryParams.subscribe((param) =>{
      if(param.pointRecharge === 'true'){
        this.appService.checkout();
      }
    });
    
    // add welcome order package to the cart
    if(this.appService.welcomePackageOnTheWay){
      this.appService.appObject.orderObject.claimWelcomePackage = true;

      // display adding welcome order package to the cart
      if (!this.appService.isWebVersion) this.appService.animationDrop = true;
      this.appService.className = 'animating'
      this.appService.displayGiftIconAmination = true;
      setTimeout(function () {
        this.className = '';
        this.animationDrop = false;
        
      }.bind(this.appService), 1000);

      // change floating button icon to cart icon 
      setTimeout(() => {
        this.appService.displayGiftIconAmination = false;
      }, 1500);

      this.appService.updateAppObject();
    }
    
    // Open cart if came back from login page
    setTimeout(() => {
      if (this.openCart || this.appService.welcomePackageOnTheWay) this.appService.openCart();

      this.appService.welcomePackageOnTheWay = false;
      this.appService.welcomePackageOnTheWayFromDirectLink = false;
    }, 500);

    this.appService.calculateCartAmounts();
  }

  ionViewWillEnter() {
    this.appService.hideCartButton = false;
  }

  ionViewWillLeave() {
    // clear all the timeouts if exists
    this.appService.dishFetchTimeoutList.forEach((timeout: any) => {
      clearTimeout(timeout);
    });
    this.appService.dishFetchTimeoutList = [];

    this.appService.hideCartButton = true;

    // Unsubscribe and assign null into menuLoadingCompleteCallBack
    // When page leaves
    if(this.menuLoadingCompleteCallBack) {
      this.menuLoadingCompleteCallBack.unsubscribe();
      this.menuLoadingCompleteCallBack = null;
    }
  }


  showa() {
    this.appService.showAlert('success', 'You have an error messages', false);

  }

  deliveryMethodChange() {
    this.router.navigate(['delivery-method'], {
      queryParams: {
        isOrderProcess: true
      }
    });
  }

  public onScroll(ev) {

    // console.log('run on scroll');

    const millis = Date.now() - this.safeScroll;
    if (Math.floor(millis) > 50) {
      const order_containers = document.querySelectorAll<HTMLElement>('.order-containers');


      let foundElement = false;
      let newThis = this;
        order_containers.forEach(function (eves): void {
          const value = eves.getBoundingClientRect().top;
        
          if ((value > 0 && value < 200) && !foundElement) {
            foundElement = true;
            const topelement = document.querySelectorAll<HTMLElement>(
              '.' + eves.getAttribute('data-scroll')
            )[0];
            newThis.scrollitem = eves.getAttribute('data-scroll');
            newThis.scrollToCenter(eves.getAttribute('data-scroll'));
            //newThis.scrollToCenter();

            return;
          }
        });
      this.safeScroll = Date.now();
    }

  }

  public scrollToCenter(className) {
    //scrolling-wrapper-new
    //setTimeout(()=>{
    const fullELement = document.querySelectorAll<HTMLElement>('.scrolling-wrapper-new')[0];
    const activeElementLeft = fullELement["children"]['0'].getElementsByClassName(className)['0'].offsetLeft;
    fullELement.scrollLeft = activeElementLeft;
    // },500);
  }

  public async openOrderTypeChooser() {

    if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.openDetails)
      this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.selectedRestaurantDetails);

    const cartModal = await this.modalController.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',
      componentProps: {
        'just_select_order_type': true,
        'currentUI': 'order-type'
      }
    });

    await cartModal.present();

  }
  
  async checkHasSecialOpenCloseDayNear() {
    this.specialOpenCloseMsg = '';
    this.showSpecialOpenCloseError = false;
    var details = {
      'type' : 'special',
      'restaurant_id': this.appService.appObject.selectedRestaurantId,
      'date': '2024-12-12'
    }
    if (details){ // details && this.appService.appObject.isAuthed
      this.appService.appObject.isLoading = true;
      await this.appService.checkHasSecialOpenCloseDayNear(details).then((data: any) => {
        if (data.status) {
          this.appService.appObject.isLoading = false
        } else if(data.code != "401"){
          this.specialOpenCloseMsg = data.msg;
          this.showSpecialOpenCloseError = true;
          this.appService.appObject.isLoading = false;
        }
      }, error => {
        this.appService.appObject.isLoading = false;
      });
    }
  }
  
}
